export default "__VITE_ASSET__D$FfP2JZ__"